import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { WavesModule, ButtonsModule } from 'angular-bootstrap-md';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
//import { ReadMoreDirective } from 'read-more-directive-angular2';
import { ImageUploadModule } from "angular2-image-upload";
import { TokenInterceptor } from './token-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiService } from './api.service';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ProfileComponent } from './profile/profile.component';
import { MatIconModule } from '@angular/material/icon';
import { ModelBikeComponent } from './model-bike/model-bike.component';
import { DeliveryTypeComponent } from './delivery-type/delivery-type.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { MatRadioModule } from '@angular/material/radio';
import { SampleComponent } from './sample/sample.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ModelComponent } from './model/model.component';
import { StorageServiceModule } from 'angular-webstorage-service';
import { AuthenticationService } from './authentication.service';
import { UserService } from './user.service';
import { ModalService } from './modal.service';
import { AuthGuard } from './auth.guard';
import { AlertService } from './alert.service';
import { LoginSignupModalComponent } from './login-signup-modal/login-signup-modal.component';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {MatMenuModule} from '@angular/material/menu';
import {MatSliderModule} from '@angular/material/slider';
import { LoginSignupComponent } from './login-signup/login-signup.component';
import { ReferralComponent } from './referral/referral.component';
import { MatButtonModule } from '@angular/material/button';
import { AlertComponent } from './alert/alert.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MomentModule } from 'angular2-moment';
import { DatePipe } from '@angular/common';
import { BikeSelectionComponent } from './bike-selection/bike-selection.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';
import { ModalDirective } from 'angular-bootstrap-md';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { UserdocumentsComponent } from './userdocuments/userdocuments.component';
import { CompletedBookingComponent } from './completed-booking/completed-booking.component';
import { OngoingBookingComponent } from './ongoing-booking/ongoing-booking.component';
import { VehicleDocumentsComponent } from './vehicle-documents/vehicle-documents.component';
import { UserdetailsComponent } from './userdetails/userdetails.component';
import { ModelDescriptionFooterComponent } from './model-description-footer/model-description-footer.component';
import { FooterProfileComponent } from './footer-profile/footer-profile.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import {TitleService} from "./title.service";
import { ExtendBookingPaymentSuccessComponent } from './extend-booking-payment-success/extend-booking-payment-success.component';
import { EditEmailDialogComponent } from './edit-email-dialog/edit-email-dialog.component';
import { EditMobileDialogComponent } from './edit-mobile-dialog/edit-mobile-dialog.component';
import { EditDldialogComponent } from './edit-dldialog/edit-dldialog.component';
import { EditAddressDialogComponent } from './edit-address-dialog/edit-address-dialog.component';
import { OpenOtpdialogComponent } from './open-otpdialog/open-otpdialog.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { AppRatingComponent } from './app-rating/app-rating.component';
import {UrlSerializer} from '@angular/router';
import { NgxGalleryModule } from 'ngx-gallery';
import { PenaltyPaymentComponent } from './penalty-payment/penalty-payment.component';
import {CookieService} from 'ngx-cookie-service';
import { AmazingTimePickerModule } from 'amazing-time-picker';
import { TestComponent } from './test/test.component';
// import { IgxTimePickerModule,IgxInputGroupModule,	IgxIconModule} from "igniteui-angular";
//  import { 	IgxToastModule } from "igniteui-angular";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    HeaderComponent,
    FooterComponent,
    ProfileComponent,
    ModelBikeComponent,
    DeliveryTypeComponent,
    LoginComponent,
    SignupComponent,
    SampleComponent,
    ModelComponent,
    LoginSignupModalComponent,
    LoginSignupComponent,
    ReferralComponent,
    AlertComponent,
    BikeSelectionComponent,
    PageNotFoundComponent,
    ModalPopupComponent,
    PaymentSuccessComponent,
    UserprofileComponent,
    UserdocumentsComponent,
    CompletedBookingComponent,
    OngoingBookingComponent,
    VehicleDocumentsComponent,
    UserdetailsComponent,
    ModelDescriptionFooterComponent,
    FooterProfileComponent,
    ResetPasswordComponent,
    ExtendBookingPaymentSuccessComponent,
    EditEmailDialogComponent,
    EditMobileDialogComponent,
    EditDldialogComponent,
    EditAddressDialogComponent,
    OpenOtpdialogComponent,
    MyProfileComponent,
    AppRatingComponent,
    PenaltyPaymentComponent,
    TestComponent
       //ReadMoreDirective
  ],
  entryComponents: [
    HeaderComponent,
    LoginSignupModalComponent,
    EditEmailDialogComponent,
    EditMobileDialogComponent,
    EditDldialogComponent,
    EditAddressDialogComponent,
    OpenOtpdialogComponent
  ],
  imports: [
    DeviceDetectorModule.forRoot(),
    BrowserModule,
    MDBBootstrapModule.forRoot(),
    AppRoutingModule,
    WavesModule,
    ButtonsModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatTabsModule,
    MatCheckboxModule,
    MatIconModule,
    MatRadioModule,
    MatButtonToggleModule,
    MatDialogModule,
    HttpClientModule,
    FormsModule,
    StorageServiceModule,
    ScrollDispatchModule,
    MatMenuModule,
    MatSliderModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MomentModule,
    MatTooltipModule,
    MatToolbarModule,
    MatListModule,
    MatSidenavModule,
    FlexLayoutModule,
    NgxGalleryModule,
    AmazingTimePickerModule,
    // IgxTimePickerModule,
		// IgxInputGroupModule,
		// IgxIconModule,
		// IgxToastModule,
    ImageUploadModule.forRoot(),
    NgCircleProgressModule.forRoot({
      "radius": 60,
      "space": -10,
      "percent": 100 - 13,
      "title": "3" + "Days \n left",
      "outerStrokeWidth": 10,
      "outerStrokeColor": "#4882c2",
      "innerStrokeColor": "#e7e8ea",
      "innerStrokeWidth": 10,
      "animateTitle": false,
      "animationDuration": 1000,
      "showUnits": false,
      "showSubtitle": false,
      "showBackground": false,
      "clockwise": false,
      //"startFromZero": false

    })
  ],

  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    DatePipe,
    MatDatepickerModule,
    AuthGuard,
    ModalService,
    ModalDirective,
    AuthenticationService,
    UserService,
    AlertService,
    ApiService,
    CookieService,
    TitleService,
    //{provide:APP_INITIALIZER, useFactory: ApiServiceFactory, deps:[ApiService],multi:true},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true

    }
    // { provide: UrlSerializer, useClass: AppRoutingModule }
  ],
  exports: [LoginSignupModalComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/app.module.ts